export interface LandCoverClass {
  value: number
  name: string
  color: [number, number, number]
}

export const LAND_COVER_CLASSES: LandCoverClass[] = [
  { value: 10, name: 'Tree Cover', color: [0, 100, 0] },
  { value: 20, name: 'Shrubland', color: [255, 187, 34] },
  { value: 30, name: 'Grassland', color: [255, 255, 76] },
  { value: 40, name: 'Cropland', color: [240, 150, 255] },
  { value: 50, name: 'Built-up', color: [250, 0, 0] },
  { value: 60, name: 'Bare / Sparse Veg', color: [180, 180, 180] },
  { value: 70, name: 'Snow and Ice', color: [240, 240, 240] },
  { value: 80, name: 'Permanent Water', color: [0, 100, 200] },
  { value: 90, name: 'Herbaceous Wetland', color: [0, 150, 160] },
  { value: 95, name: 'Mangroves', color: [0, 207, 117] },
  { value: 100, name: 'Moss and Lichen', color: [250, 230, 160] },
]

/** Classes enabled by default — all except Cropland, Built-up, and Mangroves */
export const DEFAULT_ENABLED_CLASSES = new Set(
  LAND_COVER_CLASSES.filter(c => c.value !== 40 && c.value !== 50 && c.value !== 95).map(
    c => c.value
  )
)

/** Build a 256-entry color lookup table: pixelValue → [r, g, b] or null */
export function buildColorLUT(enabledClasses: number[]): Uint8Array {
  // 256 entries × 4 channels (RGBA), default all transparent
  const lut = new Uint8Array(256 * 4)
  const enabledSet = new Set(enabledClasses)

  for (const cls of LAND_COVER_CLASSES) {
    if (!enabledSet.has(cls.value)) {
      continue
    }
    const offset = cls.value * 4
    lut[offset] = cls.color[0]
    lut[offset + 1] = cls.color[1]
    lut[offset + 2] = cls.color[2]
    lut[offset + 3] = 200 // semi-transparent
  }

  return lut
}
